import PropTypes from 'prop-types';
import React from 'react';
import { get, isNil } from 'lodash';
import { FlexRow, FlexCol } from '../sharedComponents/FlexGrid';
import ImageUnavailable from '../sharedComponents/ImageUnavailable';
import StarRating from '../sharedComponents/StarRating';
import * as utils from './utils';
import LocationName from './LocationName';

const propTypes = {
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    index: PropTypes.number,
    item: PropTypes.shape({
        preview_image_url: PropTypes.string,
        name: PropTypes.string
    }),
    onCardSelect: PropTypes.func.isRequired,
    type: PropTypes.string.isRequired,
    windowWidth: PropTypes.number
};

export const RecommendationsListCard = (props) => {

    const detailURL = utils.getTargetUri(props.item);
    const defaultPricingMessage = 'see Details';
    const priceStr = utils.getPriceRangeLabel(props.item);
    let priceUnit = utils.getPriceRangeUnit(props.item);

    if (props.item.entity_type === 'campground' && isNil(priceStr)) {
        priceUnit = defaultPricingMessage;
    }

    let cardLabel = null;
    if (priceStr) {
        cardLabel = `${props.item.name} - ${priceStr} ${priceUnit}`;
    }

    const getAverageRating = (item) => {
        return Number.parseFloat(get(item, 'average_rating', 0.0));
    };

    const averageRating = getAverageRating(props.item);

    return (
        <a
            href={detailURL}
            className="recommendations-list-card-wrapper"
            onClick={() => props.onCardSelect(props.item, detailURL, props.index)}
            aria-label={cardLabel}
            target="_blank"
            rel="noopener noreferrer">
            <FlexRow hasGutters={false} className="recommendations-list-card">
                <FlexCol xs="variable" className="mr-2">
                    <div className="recommendations-list-card--image-wrap">
                        {props.item.preview_image_url &&
                            <img
                                src={props.item.preview_image_url}
                                alt={props.item.name}
                                className="recommendations-list-card--image" />
                        }
                        {!props.item.preview_image_url &&
                            <ImageUnavailable />
                        }
                    </div>
                </FlexCol>
                <FlexCol xs="auto">
                    <FlexRow flexDirection="column" hasGutters={false}>
                        <FlexCol xs={12}>
                            <LocationName
                                className="recommendations-list-card--name"
                                name={props.item.name} />
                        </FlexCol>
                        <FlexCol xs={12} className="recommendations-list-card--location">
                            <LocationName
                                className=""
                                name={props.item.parent_name} />
                        </FlexCol>

                        {props.startDate ?
                            <FlexCol xs={12} className="recommendations-list-card--price">
                                {props.item.price_range && `${priceStr} / ${priceUnit}`}
                            </FlexCol>
                            :
                            <FlexCol xs={12} className="recommendations-list-card--star-rating">
                                {averageRating > 0 &&
                                <StarRating
                                    rating={averageRating}
                                    format="fmt2"
                                    size="sm" />
                                }
                            </FlexCol>
                        }
                    </FlexRow>
                </FlexCol>
            </FlexRow>
        </a>
    );
};

RecommendationsListCard.propTypes = propTypes;

export default RecommendationsListCard;
